export class GoalType {
    public static readonly MONETARY:number = 1;
    public static readonly NUMERIC:number = 2;
    public static readonly YESNO:number = 3;
    public static readonly PERCAPITA:number = 4;
    public static readonly PERCENTAGE:number = 5;

    public GoalTypeId:string;
    public Name:string;
    public Description:string;
    public AddUser:string;
    public AddDate:Date;
    public ChangeUser:string;
    public ChangeDate:Date;
    public DeleteFlag:boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/goal-type.ts